import React from 'react';
import colors from '../../theme/colors';
import ReactSelect, { formatDotLabel, formatDotStyles } from '../ReactSelect';

export type TesterStatus = (typeof statusOptions)[number]['value'];

const statusOptions = [
  {
    value: 'ACTIVE',
    label: 'Active',
    color: colors.statusSuccess,
  },
  {
    value: 'INACTIVE',
    label: 'Inactive',
    color: colors.statusError,
  },
  {
    value: 'PENDING',
    label: 'Pending',
    color: colors.statusPending,
  },
] as const;

export const TesterStatusPicker = ({
  value,
  isClearable,
  onChange,
}: {
  value?: TesterStatus;
  isClearable?: boolean;
  onChange: (value?: TesterStatus) => void;
}) => (
  <ReactSelect
    placeholder="status"
    isClearable={isClearable}
    value={statusOptions.find((option) => value === option.value)}
    styles={{
      multiValue: formatDotStyles,
    }}
    formatOptionLabel={formatDotLabel}
    onChange={(value) => {
      onChange(value?.value ?? undefined);
    }}
    options={statusOptions}
  />
);
